var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolTrafficAlerts01 = function SvgSolTrafficAlerts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_traffic_alerts-01_svg2__a",
    x1: 31.09,
    x2: 176.79,
    y1: 199.71,
    y2: 37.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__b",
    x1: 68.08,
    x2: 213.77,
    y1: 232.84,
    y2: 70.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__c",
    x1: 46.27,
    x2: 191.97,
    y1: 213.31,
    y2: 50.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__d",
    x1: 52.9,
    x2: 198.59,
    y1: 219.25,
    y2: 56.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__e",
    x1: 0.43,
    x2: 146.12,
    y1: 172.24,
    y2: 9.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__f",
    x1: 44.27,
    x2: 189.97,
    y1: 211.52,
    y2: 48.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__g",
    x1: 85.49,
    x2: 231.19,
    y1: 248.44,
    y2: 85.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__h",
    x1: 3.53,
    x2: 149.22,
    y1: 175.02,
    y2: 12.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__i",
    x1: 3.2,
    x2: 148.89,
    y1: 174.72,
    y2: 12.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_traffic_alerts-01_svg2__a",
    id: "sol_traffic_alerts-01_svg2__j",
    x1: -10.05,
    x2: 135.64,
    y1: 162.85,
    y2: 0.22
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 150c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33S70 158.16 70 160s-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33 150c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33 150H86.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33 163.33H86.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 136.67c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.82 123.58-7.79-23.36a10.055 10.055 0 0 0-9.42-6.86h-.11l-50.44-.07c-4.27.05-8.04 2.79-9.39 6.84l-2.17 6.52h-13l-2.17-6.52a10.03 10.03 0 0 0-9.44-6.84l-50.36.07h-.11a10.06 10.06 0 0 0-9.46 6.84l-7.79 23.37C6.05 124.8.02 131.78 0 140v23.33c0 3.68 2.98 6.67 6.67 6.67v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10h10v6.67c0 3.68 2.98 6.67 6.67 6.67v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10h46.67v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10c3.68 0 6.67-2.98 6.67-6.67V170h10v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10c3.68 0 6.67-2.98 6.67-6.67V140c-.02-8.22-6.05-15.2-14.18-16.42ZM115 102.25a3.34 3.34 0 0 1 3.1-2.29l50.44.07h.03c1.43.01 2.69.93 3.13 2.29l7 21h-40.75l-3.29-9.84a10.01 10.01 0 0 0-9.45-6.84h-11.69zm20.37 34.42H64.62l7-21.03a3.33 3.33 0 0 1 3.18-2.28h.02l50.37-.05c1.43 0 2.69.93 3.14 2.28l7.03 21.08ZM28.3 102.31a3.35 3.35 0 0 1 3.17-2.28h.04l50.35-.07c1.43.02 2.69.93 3.14 2.29l1.48 4.41H74.85a9.97 9.97 0 0 0-9.54 6.84l-3.27 9.83H21.29zM26.67 180H13.34v-10h13.33zM30 163.33H6.67V140c0-5.52 4.48-10 10-10h43.15l-2.22 6.67H43.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h3.42a16.36 16.36 0 0 0-3.08 6.67h-.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33v6.67H30.01Zm40 30H56.67v-10H70zm73.33 0H130v-10h13.33zm3.34-16.66H50v-23.33c0-5.52 4.48-10 10-10h80c5.52 0 10 4.48 10 10v23.33zm40 3.33h-13.33v-10h13.33zm6.66-16.67h-36.67v-6.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-.33c-.51-2.43-1.57-4.7-3.08-6.67h3.42c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-14.26l-2.22-6.67h43.15c5.52 0 10 4.48 10 10v23.33Z",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67 136.67c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.02 86.67h85.96c3.8.02 7.3-2.08 9.07-5.44a10.58 10.58 0 0 0-.45-10.83L108.62 4.69C106.73 1.77 103.48 0 100 0s-6.73 1.77-8.62 4.69L48.4 70.4c-2.13 3.25-2.3 7.41-.45 10.83 1.77 3.36 5.27 5.46 9.07 5.44m-3.04-12.62L96.96 8.33a3.604 3.604 0 0 1 6.08 0l42.98 65.72c.8 1.2.86 2.74.16 4a3.58 3.58 0 0 1-3.2 1.94H57.02c-1.35 0-2.58-.75-3.2-1.94-.7-1.26-.63-2.8.16-4",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 66.67,
    r: 3.33,
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 56.67c1.84 0 3.33-1.49 3.33-3.33V26.67c0-1.84-1.49-3.33-3.33-3.33s-3.33 1.49-3.33 3.33v26.67c0 1.84 1.49 3.33 3.33 3.33",
    "data-name": "Shape",
    style: {
      fill: "url(#sol_traffic_alerts-01_svg2__j)"
    }
  }));
};
export default SvgSolTrafficAlerts01;